(function () {
    'use strict';

    a3_cabin_reports.factory('CrewMealFactory', CrewMealFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CrewMealFactory
    * @description 
    * Get and Update Crew Meals 
    * @ngInject
    */
    function CrewMealFactory(GenericService, $http, apiUrl) {

        var objType = 'crewMeal';
        var objCallback = CrewMeal;
        var objCallbackRatings = RatingObj;
        var ratingSubmitResponseObj = { success: false, message: '' }

        var service = {
            getCrewMealsFromStorage: getCrewMealsFromStorage,
            setCrewMealsToStorage: setCrewMealsToStorage,
            getCrewMealFromStorage: getCrewMealFromStorage,
            sendCrewMealsRatingReport: sendCrewMealsRatingReport,
            hasRating: hasRating,
            getCrewMealsDidNotEatReasons: getCrewMealsDidNotEatReasons
        };

        /**
        * Initialize the CrewMeal
        * @memberof CrewMealFactory
        */
        function CrewMeal() {
            this.CateringMealId = null;
            this.Title = null;
            this.Description = null;
        }

        function RatingObj() {
            this.CrewMealId = null,
                this.TimeStamp = null

        }


        /**
         * Get Crew Meals
         * @memberof CrewMealFactory
         * @returns {Array} CrewMeals 
         */
        function getCrewMealsFromStorage() {
            return GenericService.list(objType, objCallback);
        }

        /**
         * Save Crew Meals to storage
         * @memberof GroundDutyFactory
         * @param {Array} objList A list of Crew Meals
         */
        function setCrewMealsToStorage(objList) {
            GenericService.saveAll(objList, objType);
        }

        /**
        * Get a specific Crew Meal
        * @memberof CrewMealFactory
        * @returns {object} CrewMeal
        */
        function getCrewMealFromStorage(cateringMealId) {
            var crewMeals = getCrewMealsFromStorage();
            if (crewMeals == null)
                return [];
            var arrayLength = crewMeals.length;
            for (var i = 0; i < arrayLength; i++) {
                if (crewMeals[i].CateringMealId == cateringMealId) {
                    return crewMeals[i];
                }
            }
        }

        /**
        * Checks if the specified crew meal has rating
        * @memberof CrewMealFactory
        * @returns {boolean} response
        */
        function hasRating(crewMealId) {
            var res = GenericService.list("CrewMealRatings", objCallbackRatings);
            return res.some(e => e.CrewMealId === crewMealId.toString());
        }

        /**
        * Sends the crew meals rating report
        * @memberof CrewMealFactory
        * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
        */
        function sendCrewMealsRatingReport(ratingForm) {
            var objectToAdd = { CrewMealId: ratingForm.CrewMealId, TimeStamp: new Date() }
            return $http.post(apiUrl + '/CrewMealsRating/SaveReport', ratingForm, { 'Content-Type': 'application/json' })
                .then(res => saveReportSuccessCallBack(res, objectToAdd))
                .catch(res => saveReportFailedCallBack(res));
        }


        /**
       * The callback function if the save report succeed
       * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
       */
        function saveReportSuccessCallBack(res, objectToAdd) {
            ratingSubmitResponseObj.success = res.data.success;
            if (res.data.success) {
                GenericService.add(objectToAdd, "CrewMealRatings", objCallbackRatings);
                ratingSubmitResponseObj.message = "Thank you for your feedback";
            }
            else {
                ratingSubmitResponseObj.message = res.data.errorMessage
            }
            return ratingSubmitResponseObj;
        }

        /**
        * Gets the choices for the dropdown if a crew member did not eat their meal
        * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
        */
        function getCrewMealsDidNotEatReasons() {
            return $http.get(apiUrl + '/CrewMealsRating/GetCrewMealsDidNotEatReasons', { 'Content-Type': 'application/json' })
                .then((res) => {
                    return res.data;
                });
        }

        /**
        * The callback function if the save report fail
        * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
        */
        function saveReportFailedCallBack(res) {
            ratingSubmitResponseObj.success = false;
            ratingSubmitResponseObj.message = "Something went wrong!"
            return ratingSubmitResponseObj;
        }

        return service;
    }

})();